import { SecondaryButton } from '@chegg-ui/button'
import { breakpoints, colors, spacing } from '@chegg-ui/theme'
import styled, { css } from 'styled-components'
import { ButtonReset } from '@chegg-wt/core/theme/sunkist/resets'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px ${spacing.px32};
`
export const HeaderLogo = styled.div``

export const Logo = styled.img`
  display: inline-block;
  position: relative;
  width: auto;
  height: 30px;
`

export const NavItem = styled(SecondaryButton).attrs({
  variant: 'text',
  size: 'medium',
})<{ hideOnMobile: boolean }>`
  display: none;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media (min-width: ${breakpoints.md.max}) {
        display: inline-block;
        && {
          color: ${colors.dark};
          line-height: 20px;
          letter-spacing: 0.3px;
          :hover {
            background: none;
          }
        }
      }
    `}
`
export const HeaderRightNav = styled.div`
  display: flex;
`
export const Nav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  height: 100%;

  &:focus-within > ul {
    display: block;
  }
`

export const AccountButtonWrapper = styled.div`
  margin: 12px 0;
`

export const UserDetails = styled.button`
  ${ButtonReset}
  height: 100%;
  display: flex;
  align-items: center;
  text-align: right;
  color: ${({ theme }) => theme.Colors.forFonts.fColor19};
  cursor: pointer;
  margin-right: 10px;

  &:hover {
    color: ${({ theme }) => theme.Colors.forFonts.fColor19};
  }
`

const navLinks = css`
  min-width: fit-content;
  color: ${({ theme }) => theme.Colors.forFonts.fColor19};
  font-size: 13px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
`

export const Email = styled.span`
  ${navLinks};
  margin-left: 3px;

  @media only screen and (max-width: ${({ theme }) =>
      adjust(themeBreakPoints.extraSmall(theme), -50)}) {
    display: none;
  }
`
